<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div
          class="cd-search-form-wrap"
          :class="showMoreSearch ? 'style-show-more' : 'style-hide-more'"
        >
          <el-form
            ref="searchForm"
            :model="searchFormData"
            class="cd-search-form"
            label-width="80px"
          >
            <el-row>
              <el-col :span="8">
                <el-form-item label="国家:" prop="area_id_arr">
                  <el-select
                    placeholder="选择国家"
                    v-model="searchFormData.area_id_arr"
                    filterable
                    multiple
                    collapse-tags
                    clearable
                    @input="selectAreaFn"
                  >
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item.area_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="资讯分类:" prop="cat_id">
                  <el-select
                    placeholder="选择资讯分类"
                    v-model="searchFormData.cat_id"
                    clearable
                  >
                    <el-option
                      v-for="item in $enums.CollectSourceType.list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="语言类型:" prop="lan_id">
                  <el-select clearable filterable placeholder="全部" v-model="searchFormData.lan_id">
                    <el-option
                      v-for="item in languageList"
                      :key="item.id"
                      :label="item.language"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="关键词:">
                  <el-row>
                    <el-col :span="16" style="padding-right: 5px;">
                      <el-input
                        placeholder="输入关键词"
                        v-model="searchFormData.q"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-select
                        placeholder="关键词类型"
                        v-model="searchFormData.qtype"
                        clearable
                        filterable
                        collapse-tags
                      >
                        <el-option
                          v-for="item in keywordsTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="处理状态:" prop="status">
                  <el-select
                    placeholder="选择处理状态"
                    v-model="searchFormData.status"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="item in $enums.CollectSourceStatus.list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="信息源:" prop="source_ids">
                  <el-select
                    placeholder="选择处理状态"
                    v-model="searchFormData.source_ids"
                    clearable
                    filterable
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="item in sourceList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="报道时间">
                  <el-col :span="11">
                    <el-date-picker
                      type="datetime"
                      placeholder="开始时间"
                      v-model="publish_time_begin_str"
                      style="width: 100%;"
                      :picker-options="pickerOptions"
                      :default-time="'00:00:00'"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2" style="text-align:center;"
                    >-</el-col
                  >
                  <el-col :span="11">
                    <el-date-picker
                      type="datetime"
                      placeholder="结束时间"
                      v-model="publish_time_end_str"
                      style="width: 100%;"
                      :picker-options="pickerOptions"
                      :default-time="'23:59:59'"
                    ></el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="抓取时间">
                  <el-col :span="11">
                    <el-date-picker
                      type="datetime"
                      placeholder="开始时间"
                      v-model="add_time_begin_str"
                      style="width: 100%;"
                      :picker-options="pickerOptions"
                      :default-time="'00:00:00'"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2" style="text-align:center;"
                    >-</el-col
                  >
                  <el-col :span="11">
                    <el-date-picker
                      type="datetime"
                      placeholder="结束时间"
                      v-model="add_time_end_str"
                      style="width: 100%;"
                      :picker-options="pickerOptions"
                      :default-time="'23:59:59'"
                    ></el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="标签：">
              <div class="cdd-status-sec2">
                <div class="cdd-status-sec22">
                  <el-tag
                    :key="tag.id"
                    v-for="(tag, index) in collectDataTags"
                    closable
                    size="medium"
                    type="success"
                    :disable-transitions="false"
                    @close="deleteTag(index)"
                  >
                    {{ tag.tag_name }}
                  </el-tag>
                </div>
                <div class="cdd-status-sec23">
                  <el-select
                    class="input-new-tag"
                    v-model="selectTagValue"
                    size="mini"
                    clearable
                    filterable
                    placeholder="选择标签"
                    style="margin-right: 5px;"
                  >
                    <el-option
                      v-for="item in selectTagsList"
                      :key="item.id"
                      :label="item.tag_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>

                  <el-button
                    class="button-new-tag"
                    size="mini"
                    type="primary"
                    icon="el-icon-plus"
                    @click="addTagClick"
                  >
                    增加
                  </el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="ID:" style="width: 400px">
              <el-input
                placeholder="输入ID(多个用英文逗号隔开)"
                v-model="searchFormData.id"
                clearable
              ></el-input>
            </el-form-item>   
            <el-form-item style="text-align: right;">
              <el-button type="primary" @click="searchClick('on')">查询</el-button>
              <el-button type="danger" @click="saveQueryClick"
                >保存当前条件</el-button
              >
              <el-button type="info" @click="resetQueryClick">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="show-more-toggle-wrapper">
          <div class="show-more-toggle-btn" @click="toggleShowMore">
            <i
              :class="
                showMoreSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
            ></i>
            <span>{{ showMoreSearch ? "收起筛选条件" : "展开筛选条件" }}</span>
          </div>
        </div>

        <div class="batch" style="margin-bottom: 10px">
          <el-button type="primary" @click="batchHandle">批量处理</el-button>
          <el-button type="danger" @click="batchDel">批量删除</el-button>
          <span v-if="selectLen > 0" style="margin-left: 10px; color: gray">(已选：{{selectLen}})</span>
          <!-- <el-button @click="batchTranslate">翻译本页标题</el-button> -->
        </div>
        <zv-table :table="table" @on-selection-change="handleSelectionChange" ref="dataTable"></zv-table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import formPageMixin from "@/mixins/formPageMixin";
import TipUtil from "@/utils/utils/TipUtil";
export default {
  name: "CollectDataList",
  mixins: [addFormMixin, formPageMixin],
  components: {},
  data() {
    let vm = this;
    return {
      // 查询条件ori
      selectLen: '',
      batchIds: "",
      showMoreSearch: false,
      searchFormDataOri: {
        area_id_arr: [],
        area_id: "",
        cat_id: "",
        lan_id: "",
        q: "",
        qtype: "",
        status: "",
        source_ids: "",
        source_id: "",
        publish_time_begin: "",
        publish_time_end: "",
        add_time_begin: "",
        add_time_end: "",
        tag_id: "",
        tag_id_arr: []
      },
      searchFormData: {},
      publish_time_begin_str: "",
      publish_time_end_str: "",
      add_time_begin_str: "",
      add_time_end_str: "",
      areaList: [], // 国家数组
      languageList: [], // 语言列表
      sourceList: [], // 信息源列表
      selectTagValue: "", // 下拉选择选中的tag值
      selectTagsList: [], // 所有tag 列表
      keywordsTypes: [
        {
          label: "标题",
          value: 1
        },
        {
          label: "内容",
          value: 2
        }
      ],
      table: {
        api: api.collectDataList,
        query: {},
        autoLoading: false,
        columns: [
          {
            type:"selection",
            width:"55"
          },
          {
            title: "资讯标题",
            key: "title",
            minWidth: "250",
            showTooltip: true
          },
          {
            title: "国家",
            key: "area_name"
          },
          {
            title: "信息源",
            key: "source_name"
          },
          {
            title: "报道时间",
            key: "publish_time",
            minWidth: "110",
            showTooltip: true,
            sortable: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.publish_time));
            }
          },
          {
            title: "抓取时间",
            key: "add_time",
            minWidth: "110",
            showTooltip: true,
            sortable: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "处理状态",
            key: "status",
            minWidth: "60",
            showTooltip: true,
            render(h, ctx) {
              let status = ctx.row.status;
              let statusText = "--";
              if (status == 1) {
                statusText = "已处理";
              } else if (status == 2) {
                statusText = "已删除";
              } else {
                statusText = "待处理";
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth: "80",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doViewDetail.bind(this, ctx.row.id)
                  }
                },
                "查看"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];
              arr.push(editBtn);

              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ],
        sortChange: vm.sortChange
      },
      formDataOri: {
        app_name: ""
      },
      formRules: {
        app_name: [
          {
            required: true,
            message: "App名称不能为空",
            trigger: "blur"
          }
        ]
      },
      deleteApi: api.editCollectData,
      deleteSuccessMsg: "删除文章成功"
    };
  },

  computed: {
    collectDataTags() {
      if (
        this.searchFormData &&
        this.searchFormData.tag_id_arr &&
        this.selectTagsList.length
      ) {
        let retArr = [];
        this.searchFormData.tag_id_arr.forEach(item => {
          let findIndex = this.selectTagsList.findIndex(
            subItem => item == subItem.id
          );
          if (findIndex > -1) {
            retArr.push(this.selectTagsList[findIndex]);
          }
        });

        return retArr;
      }
      return [];
    }
  },

  methods: {
    async getCDQueryData() {
      let res = await api.getCDQueryData();
      console.log(res);
      let processObj = Object.assign(
        {},
        this.$_.cloneDeep(this.searchFormDataOri),
        res.query
      );

      this.processSavedQuery(processObj);
      this.searchFormData = processObj;
      this.searchClick();
    },

    sortChange(column, prop, order) {
      let sortQuery = ''

      if (prop == 'add_time') {
        if (order == 'ascending') {
          sortQuery = 1
        } else if (order == 'descending') {
          sortQuery = 2
        }
      }

      if (prop == 'publish_time') {
        if (order == 'ascending') {
          sortQuery = 3
        } else if (order == 'descending') {
          sortQuery = 4
        }
      }

      if (sortQuery) {
        this.table.query.order_type = sortQuery
      }

      this.$refs.dataTable.refresh()
    },

    processSavedQuery(processObj) {
      if (processObj.cat_id) {
        processObj.cat_id = parseInt(processObj.cat_id);
      }

      if (processObj.lan_id) {
        processObj.lan_id = parseInt(processObj.lan_id);
      }

      if (processObj.source_ids) {
        processObj.source_id = processObj.source_ids.join(",")
      }

      if (processObj.qtype) {
        processObj.qtype = parseInt(processObj.qtype);
      }

      processObj.area_id_arr = processObj.area_id
        ? processObj.area_id.split(",").map(item => parseInt(item))
        : [];

      if (processObj.publish_time_begin) {
        this.publish_time_begin_str = this.$commFunc.formatDate(
          processObj.publish_time_begin
        );
      }

      if (processObj.publish_time_end) {
        this.publish_time_end_str = this.$commFunc.formatDate(
          processObj.publish_time_end
        );
      }
      if (processObj.add_time_begin) {
        this.add_time_begin_str = this.$commFunc.formatDate(
          processObj.add_time_begin
        );
      }
      if (processObj.add_time_end) {
        this.add_time_end_str = this.$commFunc.formatDate(
          processObj.add_time_end
        );
      }
      processObj.tag_id_arr = processObj.tag_id
        ? processObj.tag_id.split(",").map(item => parseInt(item))
        : [];
    },

    processSubmitQuery() {
      let processObj = this.$_.cloneDeep(this.searchFormData);
      processObj.area_id = processObj.area_id_arr.join(",");
      processObj.publish_time_begin = this.$commFunc.parseToTimestamp(
        this.publish_time_begin_str
      );
      processObj.publish_time_end = this.$commFunc.parseToTimestamp(
        this.publish_time_end_str
      );
      processObj.add_time_begin = this.$commFunc.parseToTimestamp(
        this.add_time_begin_str
      );
      processObj.add_time_end = this.$commFunc.parseToTimestamp(
        this.add_time_end_str
      );
      processObj.tag_id = processObj.tag_id_arr.join(",");
      return processObj;
    },

    async getAreaList() {
      this.areaList = await this.$commFunc.getAreaList({
        area_type: 2
      });
    },
    async getLanguageList() {
      this.languageList = await this.$commFunc.getCollectLanguageList();
    },
    async getSourceList(val) {
      let datas
      if(val == "") {
        datas = {
          page: 1,
          pagesize: this.$enums.allPageSize,
        }
      }else {
        datas = {
          page: 1,
          pagesize: this.$enums.allPageSize,
          area_id: val
        }
      }
      let res = await api.collectSourceList(datas);
      this.sourceList = res.list;
    },
    async getCollectSourceTagList() {
      let res = await api.collectSourceTagList({});
      this.selectTagsList = res.list;
    },

    async addTagClick() {
      if (this.selectTagValue == "") {
        TipUtil.message("请选择标签", "error");
        return false;
      }

      let formTagArr = this.searchFormData.tag_id_arr;
      let findIndex = formTagArr.findIndex(item => item == this.selectTagValue);
      if (findIndex > -1) {
        TipUtil.message("标签已存在，请勿重复", "error");
        return false;
      } else {
        formTagArr.push(this.selectTagValue);
      }
      this.selectTagValue = "";
    },

    deleteTag(index) {
      this.searchFormData.tag_id_arr.splice(index, 1);
    },

    searchClick(val) {
      let processObj = this.processSubmitQuery();
      if(processObj.source_ids.length > 0) {
        this.$set(processObj,"source_id",processObj.source_ids.join(","))
      }
      console.log(processObj)
      if(val == "on") {
        this.$set(processObj, "page", true);
      }
      this.$set(this.table, "query", processObj);
      this.$refs.dataTable.refresh();
    },

    async saveQueryClick() {
      let processObj = this.processSubmitQuery();
      await api.saveCDQueryData(processObj);
      TipUtil.message("搜索条件保存成功", "success");
    },

    resetQueryClick() {
      this.searchFormData = this.$_.cloneDeep(this.searchFormDataOri);
      this.$refs.searchForm.resetFields();
      this.publish_time_begin_str = "";
      this.publish_time_end_str = "";
      this.add_time_begin_str = "";
      this.add_time_end_str = "";
    },

    toggleShowMore() {
      this.showMoreSearch = !this.showMoreSearch;
    },

    saveCDQueryData() {},

    customDeleteParams(id) {
      return {
        id,
        status: 2
      };
    },
    // 国家下来菜单筛选
    selectAreaFn(val) {
      this.getSourceList(val.join(","))
    },
    // 多选操作
    handleSelectionChange(val) {
      let arrs = []
      val.forEach(item => 
        arrs.push(item.id)
      )
      this.selectLen = val.length
      this.batchIds = arrs.join(",")
    },
    // 批量删除
    async batchDel() {
      let res = await api.batchDelete({
        id: this.batchIds
      });
      if(res.error_code == 0) {
        TipUtil.message("批量删除成功！", "success");
        this.$refs.dataTable.refresh();
      }
    },
    // 批量处理
    async batchHandle() {
      let res = await api.batchChanel({
        id: this.batchIds,
        status: 1
      });
      if(res.error_code == 0) {
        TipUtil.message("批量处理成功！", "success");
        this.$refs.dataTable.refresh();
      }
    },
    // 批量翻译
    batchTranslate() {

    },
    doViewDetail(id) {
      let routeData = this.$router.resolve("/data-input/collectDataDetail?id=" + id);
      window.open(routeData.href, '_blank');
    }
  },

  created() {
    this.getCDQueryData();
    this.getAreaList();
    this.getLanguageList();
    this.getSourceList();
    this.getCollectSourceTagList();
  },

  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.cd-search-form-wrap {
  position: relative;
  overflow: hidden;
  &.style-hide-more {
    height: 40px;
  }
}

.show-more-toggle-wrapper {
  display: flex;
  justify-content: center;
  padding: 5px 0 15px;
}
.show-more-toggle-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  i {
    margin-right: 5px;
  }
}
.cd-search-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  .cdd-status-sec2 {
    display: flex;
  }

  .cdd-status-sec22 {
    margin-right: 5px;
    .el-tag + .el-tag {
      margin-left: 5px;
    }
  }
}
</style>
